module.exports = __webpack_public_path__ + "img/eyebrow_male_straight_thick.265029ef.png";